var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spectrum-Icon spectrum-Dropdown-icon",class:("spectrum-UIIcon-" + _vm.name)},[_c('use',{attrs:{"xlink:href":("#spectrum-css-icon-" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }